<template>
    <div class="c-header__navigation">
        <nav class="c-header__navigation-main" role="navigation" :aria-label="$t('nav.arialabel')" v-if="!$auth.loading">
            <ul class="c-navigation" v-if="isHomePage()">
                <li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#why'" class="c-navigation__link" v-on:click="closeMenu">
                    {{ $t('home.anchorNav.why') }}
                  </a>
                </li>
                <li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#how'" class="c-navigation__link" v-on:click="closeMenu">
                    {{ $t('home.anchorNav.how') }}
                    </a>
                </li>
                <li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#companySurvey'" class="c-navigation__link" v-on:click="closeMenu">
                    {{ $t('home.anchorNav.companySurvey') }}
                    </a>
                </li>
                <li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#partners'" class="c-navigation__link" v-on:click="closeMenu">
                    {{ $t('home.anchorNav.partners') }}
                    </a>
                </li>
                <li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#useofdata'" class="c-navigation__link" v-on:click="closeMenu">
                    {{ $t('home.anchorNav.useofdata') }}
                    </a>
                </li>
                <li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#faq'" class="c-navigation__link" v-on:click="closeMenu">
                    {{ $t('home.anchorNav.faq') }}
                    </a>
                </li>
                <!--li class="c-navigation__item" role="none">
                    <a href="#" v-scroll-to="'#contact'" class="c-navigation__link">
                    {{ $t('home.anchorNav.contact') }}
                    </a>
                </li-->
                <!--li class="c-navigation__item" v-if="!$auth.loading && !$auth.isAuthenticated">
                    <router-link
                    :to="{
                      name: '#',
                    }" v-on:click.native="login" class="c-navigation__link">
                    {{ $t('app.login') }}
                  </router-link>
                </li-->
            </ul>
            <ul class="c-navigation" v-if="!this.isHomePage() && !$auth.loading && $auth.isAuthenticated">
                <li class="c-navigation__item" v-if="!isSurveyPage()">
                  <router-link :to="{ name: 'Survey' }" class="c-navigation__link">
                    {{ $t('resources.backToResult') }}
                  </router-link>
                </li>
                <li class="c-navigation__item" v-if="$auth.getUserInfo().email_verified">
                    <router-link
                    :to="{
                      name: '#',
                    }" v-on:click.native="logout" class="c-navigation__link logout">
                    {{ $t('app.logout') }} <svg class="icon" style="fill: currentColor;"><use xlink:href="@/assets/images/sprite.svg#long-arrow-right"></use></svg>
                  </router-link>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Nav',
  async created() {
    const isAuthenticated = await this.$auth.waitForSession();
    if (isAuthenticated) {
      const token = await this.$auth.waitForToken();
      const whoAmI = await axios.get(`${process.env.VUE_APP_DIGISCORE_API}/whoAmI`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      this.$whoAmI = whoAmI;
      // eslint-disable-next-line no-underscore-dangle
      this.$auth.user = { ...this.$auth.user, id: whoAmI.data._id };
      document.cookie = `lastLogin=${whoAmI.data.lastLogin}`;
    }
  },
  methods: {
    closeMenu() {
      this.$eventHub.emit('closeMenu', false);
    },
    // Log the user in
    login() {
      this.$auth.loginWithRedirect({
        appState: { targetUrl: '/callback' },
      });
    },
    // Log the user out
    logout() {
      window.localStorage.removeItem('filter');
      window.localStorage.removeItem('sortKey');
      window.localStorage.removeItem('sortAsc');
      window.localStorage.removeItem('page');

      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
    isHomePage() {
      return this.$route && this.$route.name && this.$route.name === 'Home';
    },
    isSurveyPage() {
      return this.$route && this.$route.name && this.$route.name === 'Survey';
    },
  },
};
</script>
